__turbopack_context__.v({
  "detaljer": "ResultatKortliste-module__sjvMNG__detaljer",
  "kopier": "ResultatKortliste-module__sjvMNG__kopier",
  "kort": "ResultatKortliste-module__sjvMNG__kort",
  "lenke": "ResultatKortliste-module__sjvMNG__lenke",
  "liste": "ResultatKortliste-module__sjvMNG__liste",
  "sortering": "ResultatKortliste-module__sjvMNG__sortering",
});
